export const campaignStats = {
  serviceCount: 'Meer dan 100',
  employeeCount: 'ongeveer 25.000',
  region: 'Vlaanderen en Brussel'
};

export const quizConfig = {
  title: 'Hoe gewoon is jouw beeld van gezinszorg?',
  intro: [
    'Poetsen. Ouderen. Een handje helpen in huis.',
    'Is dat waar jij aan denkt bij gezinszorg?',
    'Tijd om je beeld even te testen. 8 korte vragen. Misschien kijk je er straks helemaal anders naar.'
  ],
  duration: '± 2 minuten',
  shareText: 'Ik deed de #niegewoon quiz. Hoe goed ken jij gezinszorg?',
  links: {
    stories: 'https://niegewoon.be/verhalen/',
    about: 'https://niegewoon.be/over-gezinszorg/'
  },
  analyticsEvents: {
    start: 'quiz_start',
    answer: 'quiz_answer',
    complete: 'quiz_complete',
    ctaClick: 'result_cta_click'
  },
  questions: [
    {
      id: 1,
      eyebrow: 'Voor iedereen?',
      question: 'Voor wie kan gezinszorg relevant zijn?',
      answers: [
        'Vooral voor ouderen.',
        'Vooral voor mensen die lichamelijke verzorging nodig hebben.',
        'Voor heel verschillende mensen, van jonge gezinnen tot ouderen.'
      ],
      correctIndex: 2,
      correctReaction: 'Exact.',
      incorrectReaction: 'Dat beeld leeft nog vaak.',
      correctFeedback: 'Gezinszorg is er niet voor één doelgroep. Jonge gezinnen, mensen met een beperking, mensen met een psychische kwetsbaarheid, mantelzorgers, ouderen of mensen die tijdelijk extra ondersteuning nodig hebben: gezinszorg kan op heel verschillende momenten in een leven betekenisvol zijn.',
      incorrectFeedback: 'Maar gezinszorg is veel breder. Ze kan relevant zijn voor jonge gezinnen, mensen met een beperking, mensen met een psychische kwetsbaarheid, mantelzorgers, ouderen en mensen die tijdelijk extra ondersteuning nodig hebben.',
      campaignLine: 'Niet één doelgroep. Maar het leven zelf.'
    },
    {
      id: 2,
      eyebrow: 'Meer dan taken',
      question: 'Wat kan gezinszorg allemaal omvatten?',
      answers: [
        'Vooral poetsen, koken en boodschappen doen.',
        'Praktische hulp, persoonlijke verzorging én psychosociale ondersteuning.',
        'Vooral administratieve hulp.'
      ],
      correctIndex: 1,
      correctReaction: 'Helemaal juist.',
      incorrectReaction: 'Bijna — er zit nog meer in.',
      feedback: 'Gezinszorg draait niet om één lijstje taken. Huishoudelijke en praktische ondersteuning, persoonlijke verzorging, een luisterend oor, structuur brengen of mantelzorgers ondersteunen kunnen allemaal deel uitmaken van gezinszorg.',
      campaignLine: 'Da’s nie gewoon helpen. Da’s mee mogelijk maken.'
    },
    {
      id: 3,
      eyebrow: 'Blijven deelnemen',
      question: 'Luc woont zelfstandig en krijgt ondersteuning van Jana. Ze helpt hem met praktische dingen. Af en toe gaan ze ook samen zwemmen. Wat toont dit vooral?',
      answers: [
        'Dat gezinszorg alleen over taken in huis gaat.',
        'Dat ondersteuning ook kan helpen om actief te blijven en deel te nemen aan het leven.',
        'Dat zwemmen een standaardtaak binnen elke gezinszorgsituatie is.'
      ],
      correctIndex: 1,
      correctReaction: 'Juist gezien.',
      incorrectReaction: 'Niet helemaal — kijk even verder.',
      feedback: 'Voor Luc betekent gezinszorg méér dan praktische hulp. Dankzij de ondersteuning van Jana blijft er ruimte voor dingen die hij graag doet, zoals zwemmen. Niet de activiteit zelf staat centraal, maar wat ze mogelijk maakt: bewegen, buitenkomen en blijven deelnemen.',
      campaignLine: 'Da’s nie gewoon meegaan. Da’s blijven doen wat belangrijk is.'
    },
    {
      id: 4,
      eyebrow: 'Ademruimte',
      question: 'Een dochter zorgt dagelijks voor haar vader met dementie en raakt stilaan overbelast. Kan gezinszorg ook voor haar een verschil maken?',
      answers: [
        'Ja. Gezinszorg kan mee ondersteuning dragen en een mantelzorger ademruimte geven.',
        'Nee. Gezinszorg ondersteunt alleen de persoon met de zorgnood.',
        'Alleen wanneer de mantelzorger zelf ziek wordt.'
      ],
      correctIndex: 0,
      correctReaction: 'Ja, precies.',
      incorrectReaction: 'Toch wel — en dat is belangrijk.',
      feedback: 'Gezinszorg kijkt ook naar de mensen rondom de cliënt. Door bepaalde ondersteuning mee op te nemen, kan een mantelzorger even op adem komen en de zorg langer volhouden.',
      campaignLine: 'Da’s nie gewoon overnemen. Da’s ademruimte geven.'
    },
    {
      id: 5,
      eyebrow: 'Opnieuw vertrekken',
      question: 'Iemand met een psychische kwetsbaarheid heeft moeite om structuur in de dag te vinden en opnieuw buiten te komen. Past dat binnen gezinszorg?',
      answers: [
        'Ja. Emotionele en psychosociale ondersteuning kunnen deel uitmaken van gezinszorg.',
        'Nee. Gezinszorg gaat alleen over huishoudelijke taken.',
        'Alleen vanaf een bepaalde leeftijd.'
      ],
      correctIndex: 0,
      correctReaction: 'Da’s inderdaad nie gewoon.',
      incorrectReaction: 'Het kan breder dan je denkt.',
      feedback: 'Een luisterend oor, structuur helpen brengen, vertrouwen opbouwen of iemand ondersteunen om opnieuw stappen te zetten in het dagelijkse leven kunnen deel uitmaken van gezinszorg.',
      campaignLine: 'Da’s nie gewoon meegaan. Da’s opnieuw durven vertrekken.'
    },
    {
      id: 6,
      eyebrow: 'Zien wat verandert',
      question: 'Waarom hebben verzorgenden soms ook een belangrijke signaalfunctie?',
      answers: [
        'Omdat ze regelmatig bij mensen thuis komen en veranderingen of problemen soms vroeg opmerken.',
        'Omdat ze zelf medische diagnoses stellen.',
        'Omdat ze beslissen welke hulp iemand verplicht moet krijgen.'
      ],
      correctIndex: 0,
      correctReaction: 'Scherp opgemerkt.',
      incorrectReaction: 'Niet helemaal — het zit in nabijheid.',
      feedback: 'Doordat verzorgenden regelmatig bij mensen thuis komen, merken ze soms vroeg signalen op van bijvoorbeeld vereenzaming, dementie, overbelasting of andere zorgnoden. Daardoor kan indien nodig tijdig bijkomende hulp worden ingeschakeld.',
      campaignLine: 'Soms zit het verschil in wat je opmerkt.'
    },
    {
      id: 7,
      eyebrow: 'Groter dan gedacht',
      question: `Hoe groot denk je dat de gezinszorg in ${campaignStats.region} ongeveer is?`,
      answers: [
        'Ongeveer 20 diensten en 2.500 medewerkers.',
        `${campaignStats.serviceCount} diensten en ${campaignStats.employeeCount} medewerkers.`,
        'Meer dan 500 diensten en ongeveer 100.000 medewerkers.'
      ],
      correctIndex: 1,
      correctReaction: 'Dat is ‘m.',
      incorrectReaction: 'Het zijn er meer dan velen denken.',
      feedback: `${campaignStats.serviceCount} diensten en ${campaignStats.employeeCount} medewerkers zetten zich in ${campaignStats.region} in om mensen thuis te ondersteunen. Gezinszorg is dus veel groter dan je misschien dacht.`,
      campaignLine: 'Niet altijd zichtbaar. Wel elke dag van betekenis.'
    },
    {
      id: 8,
      eyebrow: 'Dubbele betekenis',
      question: 'Waarom heet deze campagne eigenlijk ‘niegewoon’?',
      answers: [
        'Omdat gezinszorg alleen bedoeld is voor uitzonderlijke situaties.',
        'Omdat gezinszorg niet vanzelfsprekend is én omdat in ‘gewoon’ ook ‘woon’ zit.',
        'Omdat gezinszorg ingewikkelder is dan andere vormen van ondersteuning.'
      ],
      correctIndex: 1,
      correctReaction: 'Da’s nie gewoon goed gezien.',
      incorrectReaction: 'Er zit een kleine woordspeling in.',
      feedback: '‘Nie gewoon’ heeft een dubbele betekenis. Gezinszorg is niet zomaar een taak: de impact ervan is bijzonder en vaak onmisbaar. En in ‘gewoon’ zit ook ‘woon’: een verwijzing naar zelfstandig thuis kunnen blijven wonen.',
      campaignLine: 'Gezinszorg. Da’s niegewoon.'
    }
  ],
  results: [
    {
      min: 0,
      max: 3,
      title: 'Gezinszorg heeft je verrast.',
      text: 'En je bent zeker niet de enige. Gezinszorg wordt nog vaak onderschat of herleid tot praktische hulp. Maar achter kleine vormen van ondersteuning zit vaak een wereld van verschil.'
    },
    {
      min: 4,
      max: 6,
      title: 'Je kijkt al verder dan het klassieke beeld.',
      text: 'Je weet duidelijk dat gezinszorg meer is dan hulp in het huishouden. En toch zaten er misschien nog een paar verrassingen tussen.'
    },
    {
      min: 7,
      max: 8,
      title: 'Da’s nie gewoon goed gezien.',
      text: 'Jij hebt een breed beeld van gezinszorg. Niet de taken staan centraal, maar wat mensen dankzij die ondersteuning kunnen blijven doen.'
    }
  ]
};